import { handleFindLayoutComponentOptions, getAttrById, isExist, simpleDeepClone } from "./index"

/**
 *
 * @returns 可配置项数据对象
 * @example this.$getOptions[数据名]
 *
 * 在computed中使用的时候要精确返回，例如：
 *  options: {
             content: '我是测试内容111',
             style: {
                 fontFamily: 'default',
                 fontSize: '24',
             },
         }，
         上述情况，如果要使用fontsize，请直接写为👇下列形式：
         <p v-modle="fontSize"/>
         fontSize: {
             get() {this.getotions.style.fontSize}，
             set() {.........}
         }；
         切记不要写成👇下面这种情况，这种情况在set时会有触发失效问题：
         <p v-modle="font.fontSize"/>
         font: {
             get() {this.getotions.style},
             set() {.........}
         }；
 */
export function getOptions(ids) {
  const _ids = ids ? ids : { ...this.$store.state.states.activeID }
  const stage = this.$store.state[this.request_prefix]
  if (isExist(_ids.directionIndex)) {
    //自由布局里面的title部分
    let rectAttr = null
    if (typeof _ids.elementInAutoLayoutId === "number") {
      rectAttr = getAttrById(stage, _ids, "elementInAutoLayout")
    } else {
      rectAttr = getAttrById(stage, _ids, "rect").options
    }
    if (_ids.changingTitleElement) {
      return rectAttr.titleOptions[_ids.directionIndex]
    }
    return rectAttr.titleOptions[_ids.directionIndex].elementOptions.find(
      it => it.elementInLayoutId === _ids.elementInLayoutId
    ).options
  }
  if (isExist(_ids.rect_id)) {
    if (!isExist(_ids.uid)) {
      if (isExist(_ids.elementInSwiperId)) {
        return getAttrById(stage, _ids, "elementInSwiper")
      }
      if (isExist(_ids.swiperContent_id)) {
        return getAttrById(stage, _ids, "swiperContent")
      }
      if (isExist(_ids.elementInDataGridId)) {
        // 数据列表内的组件
        return getAttrById(stage, _ids, "elementInDataGrid")
      }
      if (isExist(_ids.cellId) && !isExist(_ids.elementInDataGridId)) {
        // 数据列表内的单元格
        return getAttrById(stage, _ids, "dataGridCell")
      }
      // 画布里的自动布局
      if (isExist(_ids.elementInAutoLayoutId)) {
        return getAttrById(stage, _ids, "elementInAutoLayout")
      }
      // 选中rect情况
      return getAttrById(stage, _ids, "rect")?.options
    } else {
      // 自由布局里的自动布局
      if (isExist(_ids.elementInAutoLayoutId)) {
        let rectAttr = getAttrById(stage, _ids, "elementInAutoLayout")
        if (rectAttr?.elementOptions) {
          return rectAttr.elementOptions.find(it => it.elementInAutoLayoutId === _ids.elementInAutoLayoutId)
        } else {
          return rectAttr // 自动布局里的自由布局下的元素
        }
      }
      // 选中布局组件情况
      const pOptions = getAttrById(stage, _ids, "rect").options.rows
      let result = handleFindLayoutComponentOptions(pOptions, _ids.uid)
      return _ids.elementInLayoutId !== null
        ? result.find(it => it.elementInLayoutId === _ids.elementInLayoutId)
        : result
    }
  } else {
    const _stage = this.$store.state[this.request_prefix]?.page
    // 选中画布的情况
    if (_stage?.children.find(it => it.container_id === _ids.container_id)?.hasOwnProperty("options")) {
      return _stage.children.find(it => it.container_id === _ids.container_id).options
    } else {
      return {}
    }
  }
}
//修改可配置项函数
/**
 *
 * @param {String | Number} val 必填,需要修改的数据值
 * @param { String } content_name 必填，需要修改的数据值的键名
 * @param { Boolean } deep 必填，需要修改的数据值是否是某个键名的里面那一层的？
 * @param { String } optionName 可选，传了deep就要传这个，对应的某个键名
 * @param { Object } ids 可选
 * @param { Object } recordDisable 禁止记录状态
 *
 *                                 新值👇   新值键名👇  👇是否深度修改
 * @example this.$changeOptionsEV(newVal, 'content', false)
 * 👆这个例子会对option中的content键对应的值进行修改，将改成newVal对应的值。
 *
 *                                 新值👇   新值键名👇    👇是否深度修改   👇深度修改哪个对象中的数据？
 * @example this.$changeOptionsEV(newVal, 'lineHeight', true,         'style')
 * 👆这个例子会对option中的style键对应的对象中的lineHeight对应的值进行修改，将改成newVal对应的值。
 *
 * 第三个参数，深度修改，指的是，如下例：
 * options: {
             content: '我是测试内容111',
             style: {
                 fontFamily: 'default',
                 fontSize: '24',
             },
         }
         如👆所示，content表示非深度修改，第三个参数为false
                  style里的fontSize为深度修改，第三个参数为ture
        ！！！！！
        ！！！！！注意！深度修改只能是options对象里还有一个对象，修改该对象中的值，只能有一层，所以请注意menu开发的格式。
 */
export function changeOptionsEV(val, content_name, deep, optionName, rectIds, recordDisable) {
  let ids = rectIds
    ? rectIds
    : Array.isArray(this?.$options?._propKeys) && this?.$options?._propKeys.find(it => it === "myid")
    ? this.myid
    : this.$store.state.states.activeID
  //特殊场景处理开始（changeOptionsEV逻辑无关）---------------
  const opt = getOptions.call(this, ids)
  if (opt && opt.length > 1) {
    if (optionName && opt[optionName][content_name]) {
      if (opt[optionName][content_name] === val) {
        return
      }
    } else {
      if (opt[content_name] && opt[content_name] === val) {
        return
      }
    }
  }
  //特殊场景处理结束（changeOptionsEV逻辑无关）---------------
  const _ids = ids ? ids : this.ids
  let result = null
  if (val !== undefined && content_name !== undefined) {
    //result用于deep为true的场景 其余场景均随便给result赋一个有效值即可
    const stage = this.$store.state[this.request_prefix]
    if (isExist(_ids.directionIndex)) {
      let rectAttr = getAttrById(stage, _ids, "rect").options
      if (typeof _ids.elementInAutoLayoutId === "number" && !isNaN(_ids.elementInAutoLayoutId)) {
        rectAttr = getAttrById(stage, _ids, "elementInAutoLayout")
      }
      if (_ids.changingTitleElement) {
        result = simpleDeepClone(rectAttr.titleOptions[_ids.directionIndex])
      } else {
        result = simpleDeepClone(
          rectAttr.titleOptions[_ids.directionIndex].elementOptions.find(
            it => it.elementInLayoutId === _ids.elementInLayoutId
          ).options
        )
      }
    }
    if (!deep) {
      result = true
    } else {
      if (isExist(_ids.uid)) {
        // 设置布局组件内的组件
        let pOptions = null
        if (typeof _ids.elementInAutoLayoutId === "number" && !isNaN(_ids.elementInAutoLayoutId)) {
          pOptions = getAttrById(stage, _ids, "elementInAutoLayout")?.rows
        } else {
          pOptions = getAttrById(stage, _ids, "rect").options.rows
        }
        const uid = this.$store.state.states.activeID.uid ? this.$store.state.states.activeID.uid : _ids.uid
        result = handleFindLayoutComponentOptions(pOptions, uid).find(
          it => it.elementInLayoutId === _ids.elementInLayoutId
        )
      } else if (_ids.rect_id === null) {
        //设置container的数据
        result = simpleDeepClone(
          getAttrById(this.$store.state[this.request_prefix], { container_id: _ids.container_id }).options
        )
      } else if (isExist(_ids.elementInSwiperId)) {
        // 设置轮播组件内的组件的数据
        result = simpleDeepClone(getAttrById(this.$store.state[this.request_prefix], _ids, "elementInSwiper"))
      } else if (isExist(_ids.elementInDataGridId)) {
        result = simpleDeepClone(getAttrById(this.$store.state[this.request_prefix], _ids), "elementInDataGrid")
      } else if (isExist(_ids.cellId) && !isExist(_ids.elementInDataGridId)) {
        result = simpleDeepClone(getAttrById(this.$store.state[this.request_prefix], _ids), "dataGridCell")
      } else if (isExist(_ids.elementInLayoutId)) {
        // 设置自由布局组件内的组件的数据
        result = simpleDeepClone(getAttrById(this.$store.state[this.request_prefix], _ids, "autoLayout").elementOptions)
      } else if (isExist(_ids.elementInAutoLayoutId)) {
        result = simpleDeepClone(getAttrById(this.$store.state[this.request_prefix], _ids, "elementInAutoLayout"))
      } else {
        // 设置rect的数据
        result = simpleDeepClone(getAttrById(this.$store.state[this.request_prefix], _ids, "rect").options)
      }
    }
    if (result) {
      let param = null
      if (!deep) {
        param = {
          option_name: content_name,
          option_val: val
        }
      } else {
        result[optionName][content_name] = val
        param = {
          option_name: optionName,
          option_val: result[optionName]
        }
      }
      const completeParam = Object.assign(param, _ids)
      if (!recordDisable && !sessionStorage.getItem("nextHistoryNotSave")) {
        this.$addHistory({
          type: "update",
          stateType: "updateProperty",
          payload: completeParam
        })
      }
      // 自动布局下-自由布局-单元格 属性修改走向不对，应该走 updateColsOption
      if (isExist(_ids.uid) && isExist(_ids.elementInAutoLayoutId) && isExist(_ids.elementInLayoutId)) {
        this.$store.dispatch(this.request_prefix + "/changeAutoLayoutOptions", completeParam)
      } else if (isExist(_ids.uid) && isExist(_ids.elementInLayoutId) && !isExist(_ids.elementInAutoLayoutId)) {
          this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParam)
      } else if(isExist(_ids.uid)){
          completeParam.option_name = "componentBoxOptions-" + completeParam.option_name
          this.$store.dispatch(this.request_prefix + "/updateColsOption", completeParam)
      } else if (isExist(_ids.directionIndex)) {
        if (_ids.changingTitleElement) {
          this.$store.dispatch(this.request_prefix + "/changeTitleElement", completeParam)
        } else {
          this.$store.dispatch(this.request_prefix + "/changeTitleOptions", completeParam)
        }
      } else if (isExist(_ids.elementInSwiperId)) {
        this.$store.dispatch(this.request_prefix + "/changeSwiperOptions", completeParam)
      } else if (isExist(_ids.elementInDataGridId)) {
        completeParam.isSync = true
        this.$store.dispatch(this.request_prefix + "/changeDataGridOptions", completeParam)
      } else if (isExist(_ids.cellId) && !isExist(_ids.elementInDataGridId)) {
        completeParam.isSync = true
        this.$store.dispatch(this.request_prefix + "/changeDataGridOptions", completeParam)
      } else if (isExist(_ids.elementInAutoLayoutId)) {
        this.$store.dispatch(this.request_prefix + "/changeAutoLayoutOptions", completeParam)
      } else {
        this.$store.dispatch(this.request_prefix + "/changeOptions", completeParam)
      } 
    }
  }
  if (this.hasOwnProperty("getOptionsHandle")) {
    this.getOptionsHandle()
  }
}

/**
 * 修改页面的值
 * @param {*} payload
 * @param {*} recordDisable
 */
export function changePageAttribute(payload, recordDisable) {
  if (!recordDisable && !sessionStorage.getItem("nextHistoryNotSave")) {
    this.$addHistory({
      type: "update",
      stateType: "updatePageProperty",
      payload: payload
    })
  }
  if (payload?.option_name === "editPageThemeColor") {
    // 主题色双端一起修改
    this.$store.dispatch("stage/changeAttribute", payload)
    this.$store.dispatch("appStage/changeAttribute", payload)
  } else {
    this.$store.dispatch(this.request_prefix + "/changeAttribute", payload)
  }
}
